"use client";

import React from "react";
const partners = [{
  id: 1,
  name: "TechFlow",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_techcorp.png"
}, {
  id: 2,
  name: "VortexDigital",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_innovatex.png"
}, {
  id: 3,
  name: "CloudPulse",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_globalsys.png"
}, {
  id: 4,
  name: "NexusSystems",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_nexus.png"
}, {
  id: 5,
  name: "QuantumMedia",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_quantum.png"
}, {
  id: 6,
  name: "StellarGrowth",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_stellar.png"
}, {
  id: 7,
  name: "VanguardLabs",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_vanguard.png"
}, {
  id: 8,
  name: "ApexSolutions",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600169/img/logo_apex.png"
}];
export default function GlobalPartners() {
  return <section data-section-id="133369" id="trusted-partners" className="dark bg-background text-foreground border-y border-white/5 py-10 overflow-hidden flex relative before:absolute before:left-0 before:top-0 before:z-10 before:h-full before:w-32 before:bg-gradient-to-r before:from-background before:to-transparent after:absolute after:right-0 after:top-0 after:z-10 after:h-full after:w-32 after:bg-gradient-to-l after:from-background after:to-transparent">
      <style>{`
        @keyframes marquee {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
      `}</style>

      {}
      <div className="flex shrink-0 min-w-full items-center justify-around gap-16 px-8 animate-marquee">
        {partners.map((partner, i) => <div key={partner.id} data-index={i} className="flex items-center justify-center">
            <img src={partner.logo} alt={`${partner.name} logo`} className="h-8 w-auto max-w-[140px] object-contain opacity-50 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0 hover:drop-shadow-[0_0_15px_rgba(20,255,255,0.3)]" />
          </div>)}
      </div>

      {}
      <div aria-hidden="true" className="flex shrink-0 min-w-full items-center justify-around gap-16 px-8 animate-marquee">
        {partners.map((partner, i) => <div key={`dup-${partner.id}`} data-index={i} className="flex items-center justify-center">
            <img src={partner.logo} alt={`${partner.name} logo`} className="h-8 w-auto max-w-[140px] object-contain opacity-50 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0 hover:drop-shadow-[0_0_15px_rgba(20,255,255,0.3)]" />
          </div>)}
      </div>
    </section>;
}